export default {
    /**
     * GET
     */
    getPickupLocations: function(  ){
        return axios.get( '/settings/locations/pickup' );
    },
}